import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import Button from '../../components/controls/Button';
import Modal from '../../components/Modal';
import { useApiClient } from '../../context/ApiClientContext';
import basicServiceHandler from '../../services/basicServiceHandler';
import { axiosErrorToUserMessage } from '../../services/axios';

function DeleteUserButton(props) {
  const {
    username, fetchUsers, setSuccessMessage, setErrorMessage,
  } = props;

  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const apiClient = useApiClient();

  const handleConfirmDelete = async () => {
    if (username) {
      setLoading(true);
      basicServiceHandler(
        () => apiClient.deleteUser(username),
        (response) => {
          if (response.status === 200) {
            setSuccessMessage(`${username} deleted successfully`);
            fetchUsers();
          } else {
            setErrorMessage(response.data);
          }
          setLoading(false);
        },
        (error) => {
          setErrorMessage(axiosErrorToUserMessage(error));
          setLoading(false);
        },
      );
    }
    setDialogOpen(false);
  };

  return (
    <>
      <Tooltip title="Delete user">
        <IconButton onClick={() => setDialogOpen(true)} data-testid="deleteUserIcon">
          <DeleteForeverOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Modal
        isOpen={dialogOpen}
        handleClose={() => setDialogOpen(false)}
        title="Delete User"
        data-testid="deleteUserModal"
      >
        <Typography variant="body1" sx={{ marginBottom: '1rem' }}>
          Are you sure you want to permanently delete the user
          {' '}
          <Typography component="span" sx={{ fontWeight: 'bold' }}>
            {username}
          </Typography>
          {' '}
          from our database? This action cannot be undone.
        </Typography>
        <Button
          text="Cancel"
          variant="outlined"
          color="primary"
          onClick={() => setDialogOpen(false)}
          sx={{ marginRight: '1rem' }}
          data-testid="deleteUserCancelButton"
        />
        <Button
          text={loading ? 'Deleting...' : 'Delete'}
          variant="contained"
          color="primary"
          onClick={handleConfirmDelete}
          disabled={loading}
          data-testid="deleteUserConfirmButton"
        />
      </Modal>
    </>
  );
}

DeleteUserButton.propTypes = {
  username: PropTypes.string.isRequired,
  fetchUsers: PropTypes.func.isRequired,
  setSuccessMessage: PropTypes.func.isRequired,
  setErrorMessage: PropTypes.func.isRequired,
};

export default DeleteUserButton;
